import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { ImageUrl } from '../../utils/constants';
const CalendarLinkBgImage = ImageUrl + "/user-dashboard/calender-link+banner.svg";





const MonthlythemeContainer = styled.div`
  width: 1246px;
  height: 134px;
  border-radius: 12px;
  margin-bottom: 20px;
  position: relative;

  ${'' /* background: ${({ backgroundColor }) => backgroundColor}; */}
  background-image: ${({ backgroundImage }) =>
    backgroundImage ? `url(${backgroundImage})` : "none"};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .insideContainer {
    padding: 30px;
    width: 700px;
    position: relative;
    z-index: 2; /* text above background */

    .monthly-theme-text {
      ${'' /* color: #A62F3D; */}
      color:${({fontColor})=>fontColor ? fontColor :"#A62F3D" };
      font-family: ${({ fontFamily }) => fontFamily ?? "Lato"};
      font-size: 18px;
      font-weight: 700;
      line-height: 30px;
    }

    .focus-on-fitness-text {
      ${'' /* color: #A62F3D; */}
      color:${({fontColor})=>fontColor ? fontColor :"#A62F3D" };
      font-family: ${({ fontFamily }) => fontFamily ?? "Lato"};
      font-size: 32px;
      font-weight: 700;
      line-height: 48px;
    }
  }
`;


// const MonthlythemeContainer = styled.div`
//     width: 1246px;
//     ${'' /* width: 100%; */}
//     height: 134px;
//     border-radius: 12px;
//     ${'' /* background:  #F6D5D6; */}
//     background: ${({ backgroundColor }) => backgroundColor ? backgroundColor: ' #F6D5D6'};
//     margin-bottom:20px;

//    .insideContainer{
//     padding:30px;
//     width:537px;

//     .monthly-theme-text {
//         color:  #A62F3D;
//         font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
//         font-size: 18px;
//         font-style: normal;
//         font-weight: 700;
//         line-height: 30px; 
//     }
//     .focus-on-fitness-text {
//         color:  #A62F3D;
//         font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
//         font-size: 32px;
//         font-style: normal;
//         font-weight: 700;
//         line-height: 48px;
//     }
//    }

//    .imageCard{
//     width: 223px;
//     height: 124px;
//     margin:5px 0px;
//     cursor:pointer;
//     border-radius: 8px;
//     visibility: visible;  
//     display: flex;
//     justify-content: center;
//     align-items: center;

//     >img{
//       width:100%;
//       height:100%;
//       border-radius: 8px;
      
//     }
// `;


const TopCardsContainer = styled.div`
    display: flex;
    gap:24px;
`;



const TopCards= styled.div`
   width: 400px;
   height: 200px;
   flex-shrink: 0;
   padding:20px;
   border-radius: 12px;
   ${'' /* border: 0.75px solid #DCDCDC;
   background:  #FEFEFE; */}

  border: 0.75px solid ${({ tierStyle }) => tierStyle?.border || '#DCDCDC'};
  background: ${({ tierStyle }) => tierStyle?.background || '#FEFEFE'};

   .headingContainer{
    display: flex;
    align-items: center;
    gap:4px;

    .iconContainer{
        width:18px;
        height:18px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
   }

   .wellnessTipHeading{
    color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
    ${'' /* color:  #184A61; */}
    font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; 
   }

   .wellnessTipText{
    margin-top:16px;
    color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
    ${'' /* color:  #184A61; */}
    ${'' /* font-family: Lato; */}
    font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
   }

   .pointsText{
    color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
    font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    margin-top:8px;
   }

   .redirectionText{
    margin-top:26px;
    color:${({redirectionTextColor})=> redirectionTextColor ? redirectionTextColor : '#DA6C74'};
    text-align: end;
    font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    cursor:pointer;
   }


   .noHealthData{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-top:8px;
   }

   .congratesText{
    color: var(--Crimson-Blush-600, #C13D4D);
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    margin-top:8px;
   }
   .rewards-point{
      display:flex;
      margin-top:12px;
    }

    .tier-details{
      margin-left:20px;
      color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
    }

    .active-tier{
     font-weight: 700;
    }

    .top-initiatives{
      display:flex;
      margin-top:14px;
      justify-content:space-between;

    }
    .top-three-initiatives{
      display:flex;
      overflow: visible;
    }
`;

const TopThreeInitiativesCard = styled.div`
  position: relative;
  margin-right: 16px;
  display: inline-block;
  cursor:pointer;

  &:hover {
    z-index: 10; /* ✅ critical */
  }
    .icon{
      background: ${({ background }) => background ? background : '#F6D5D6'};
      border-radius:50%;
      width:48px;
      height:48px;
      display:flex;
      align-items:center;
      justify-content:center;
    }
  .initiative-image{
    width:24px;
    height:24px;
  }


  /* Tooltip */
  .tooltip {
    position: absolute;
    ${'' /* bottom: 58px; */}
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    cursor:pointer;

    padding: 6px 10px;
    font-family: Lato;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 18px;

    border-radius: 4px;
    border: 0.75px solid #DCDCDC;
    background: #FEFEFE;
    color: #184A61;

    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease;
    z-index: 10;

  }

  &:hover .tooltip {
    opacity: 1;
    visibility: visible;
  }

  .tooltip::before {
  content: '';
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent #FEFEFE transparent;
}

/* Arrow FILL */
.tooltip::after {
  content: '';
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 7px;
  border-style: solid;
  border-color: transparent transparent #FEFEFE transparent;
}
`



const ProgressBarContainer = styled.div`
    width: 360px;
    height: 30px;
    flex-shrink: 0;
    border-radius: 24px;
    ${'' /* background:  #F6D5D6; */}
    margin-top:16px;
    overflow: hidden;
    background: ${({ tierStyle }) => tierStyle?.progressBg || '#F6D5D6'};

    .progress {
      width: 331px;
      width: ${({ progressPercent }) => progressPercent ? progressPercent : 0}%;
      height: 30px;
      flex-shrink: 0;
      border-radius: 24px;
      background: ${({ ctaColor,tierStyle }) => ctaColor ? ctaColor : tierStyle?.progress || '#DA6C74' };
      ${'' /* background: ${({ ctaColor }) => ctaColor ? ctaColor : ' #DA6C74'}; */}
      ${'' /* background:  #DA6C74; */}
    }

`;



const Layout = styled.div`
  width: 100%;
  border-radius:6px;
  padding: ${({ padding }) => (padding ? padding : "0 0 25px 0")};
  margin: ${({ margin }) => (margin ? margin : "0 0 25px 0")};
  .cardWrapper{
    width:100%;
    display:flex;
    flex-wrap:wrap;
    padding-left:0px;
    margin-top:25px;
    .cardDiv{
      width:399px;
    }
  }
  .arrows{
    display:flex;
    align-items:center;
    
    width:auto 0 auto auto;
    .iconBackground{
      width:32px;
      height:32px;
      border-radius:3px;
      // background: rgba(0, 122, 177, 0.05);
      cursor:pointer;
      display:flex;
      justify-content:center;
      align-items:center;
    }
    .text{
      color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
      text-align: center;
      font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 36px;
      margin: auto 12px auto 12px;
      display:flex;
    }
    .iconPlaceholder{
      width:32px;
      height:32px;
    }
  }
.headingMain{
  width:100%;
  display:flex;
  justify-content:space-between;
  ${'' /* padding: 0px 0px 0px 8px; */}
  .heading{
    font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
    color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
    align-items: center;
    display: flex;
  }
  .seeAll{
    font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
    text-decoration: underline;
    cursor:pointer;
  }
}
.card{
  width: ${({ width }) => (width ? "399px !important" : "100%")};
}


.redirectionText{
    color:  #DA6C74;
    text-align: end;
    font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
    font-size:${({ isFontSize }) => (isFontSize ? isFontSize : '12px')};
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    cursor:pointer;
    display:flex;
    justify-content:center;
    align-items:center;
   }


   .iconContainer{
    display:flex;
    justify-content:center;
    align-items:center;
    width:32px;
    height:32px;
    cursor:pointer;
   }



   .wellnessText{
    color:  #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
   }


   .dropdown-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 20px 8px;
    ${'' /* margin-top: 10px; */}
  }


   .fallback-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
   }

  .rightImage{
    height:100px;
  }

`;



const Container = styled.div`
  width: 100%;
  border-radius: 8px;
  margin-top: 16px;
  
  .card {
    width: 100%;
    border:none;
  }
`;



// const SliderContainer = styled.div`
//   width: 100%;

//   .slick-slider {
//     width: 100%;
//     margin: ${({marginValue}) => marginValue ? marginValue : '20px 0 10px'};
//     padding: ${({padding}) => padding ? padding : ''};
//     box-shadow: none;

//     .slick-slide{
//       margin: 0px;
//       display: flex !important;
//       justify-content: center;
//       justify-content: ${({content}) => content ? content : ''};
//       margin: ${({margin}) => margin ? margin : ''};
//       @media (max-width: 600px){
//         margin: 0 auto;
//       }
//     }
//     .slick-prev {
//       display:none !important;
//     }

//     .slick-next {
//       display:none !important;
//     }
//       [dir="rtl"] .slick-next:before {
//         content: "‹";
//       }
//   }
// `;


// const SliderContainer = styled.div`
//   width: 100%;

//   .slick-slider {
//     width: 100%;
//     margin: ${({ marginValue }) => (marginValue ? marginValue : "20px 0 10px")};
//     padding: ${({ padding }) => (padding ? padding : "")};
//     box-shadow: none;

//     /* 🔥 Hide the extra blurred card overflow */
//     .slick-list {
//       overflow: hidden !important;
//     }

//     /* 🔥 Ensure slides line up properly */
//     .slick-track {
//       display: flex !important;
//     }

//     .slick-slide {
//       margin: 0px;
//       display: ${({ display }) => (display ? display : "block")};
//       justify-content: ${({ content }) => (content ? content : "")};
//       margin: ${({ margin }) => (margin ? margin : "")};
//       @media (max-width: 600px) {
//         margin: 0 auto;
//       }
//     }

//     .slick-prev {
//       display: none !important;
//     }

//     .slick-next {
//       display: none !important;
//     }

//     [dir="rtl"] .slick-next:before {
//       content: "‹";
//     }
//   }
// `;



const SliderContainer = styled.div`
  width: 100%;
  
  .slick-slider {
    width: 100% !important;
    margin: ${({ marginValue }) => (marginValue ? marginValue : "20px 0 10px")};
    box-shadow: none;

    .slick-list {
      overflow: hidden !important;
    }

    .slick-track {
      display: flex !important;
    }

    .slick-slide {
      display: flex !important;
      outline: none !important;
    }

    .slick-slide > div {
      width: 100%;
      padding: 0 !important;
      margin: 0 !important;
      outline: none !important;
    }

    .slick-dots {
      position: absolute;
      bottom: -25px;
      left: 50%;
      transform: translateX(-50%);
      display: flex !important;
      gap: 8px;
      justify-content: center;
    }

    .slick-dots li {
      width: 10px;
      height: 10px;
      margin: 0;
    }

    .slick-dots li button {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #d9d9d9;
      border: none;
      padding: 0;
    }

    .slick-dots li button:before {
      display: none;
    }

    .slick-dots li.slick-active button {
      background: #DA6C74;
    }

    .slick-prev,
    .slick-next {
      display: none !important;
    }
  }
`;


/* .slick-slide,
  .slick-track,
  .slick-list {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    height:344px;
} */
// .slick-slide:focus {
//   outline: none !important;
//   border:none !important;
// }

// .slick-slide  {
//   ${'' /* width: auto !important; */}
//   outline: none !important;
//   border: none !important;
//   box-shadow: none !important;
// }  


//     .slick-dots li button:before {
//   display: none;
// }

//     .slick-dots li.slick-active button:before {
//       color: #DA6C74; /* active dot color, adjust to match your design */
//     }
   
//     .slick-slide {
//       ${'' /* width: 1225px !important; */}
//       ${'' /* width: auto !important; */}
//       display:flex;
//       border:none !important;
//       outline: none !important;
//       justify-content: ${({ content }) => (content ? content : "")};
//       margin: ${({ margin }) => (margin ? margin : "")};
//       @media (max-width: 600px) {
//         margin: 0 auto;
//       }
//     }



//    .slick-dots li.slick-active button {
//      background: #DA6C74; /* 🔵 your active color */
//      width: 10px; /* optional: slightly bigger when active */
//      height: 10px;
//    }

//     .slick-prev,
//     .slick-next {
//       display: none !important;
//     }

//     [dir="rtl"] .slick-next:before {
//       content: "‹";
//     }

//     ${'' /* * {
//   border: none !important;
//   outline: none !important;
//   box-shadow: none !important;
// } */}

// *:not(.slick-slider *):not(.slick-track):not(.slick-slide) {
//   border: none !important;
//   outline: none !important;
//   box-shadow: none !important;
// }
   
//   }
// `;



// const CompanyCard = styled.div`
//   width: ${({ width }) => (width ? width : "100%")};
//   display: flex;
//   ${'' /* border-radius: 6px; */}
//   ${'' /* cursor: pointer; */}
//   cursor: ${({ isCursorPointer }) => (isCursorPointer ? isCursorPointer : "pointer")};
//   box-shadow: none;
//   padding:  0 16px 0 0;
//   ${'' /* flex-wrap: wrap; */}
//   .date{
//     width:100%;
//     height:32px;
//     display:flex;
//     margin-bottom:10px;
//     align-items: center;
//     .icon{
//       width:24px;
//       height:24px;
//       >img{
//         width:100%;
//         height:100%;
//       }
//     }
//     .iconV1{
//       display:flex;
//       justify-content:center;
//       align-items:center;
//       width:24px;
//       height:24px;
//       >img{
//         width:100%;
//         height:100%;
//       }
//     }
//     .detail{
//       color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
//       font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
//       font-size: 16px;
//       font-style: normal;
//       font-weight: 400;
//       line-height: 20px;
//       margin-left:20px;
//       display:flex;
//       align-items:center
//     }
//   }
//   .eventLabel{
//     height:0px;
//     width:100%;
//     position: relative;
//     /* left: 10px;
//     top: 10px; */

//     .label{
//     height:24px;
//     width:100px;
//     display:flex;
//     background:white;
//     border-radius:3px;
//     font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
//     font-size: 12px;
//     font-weight: 400;
//     line-height: 16px;
//     letter-spacing: 0px;
//     text-align: center;
//     color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
//     position:relative;
//     align-items: center;
//     justify-content: center;
//     top:10px;
//     left:10px;
//     }
//   }
//   .imageCard{
//     width: 536px;
//     height: 343px;
//     ${'' /* cursor:pointer; */}
//     cursor: ${({ isCursorPointer }) => (isCursorPointer ? isCursorPointer : "pointer")};
//     ${'' /* border-radius: 8px 0 0 8px; */}
//     border-radius: 5px 0px 0px 5px;
//     visibility: hidden;
//     >img{
//       width:100%;
//       height:100%;
//       ${'' /* border-radius: 8px 0 0 8px; */}
//       border-radius: 5px 0px 0px 5px;
      
      
//     }
//   }

//     .imageCardUserDashboard{
//     width: 536px;
//     height: 343px;
//     ${'' /* cursor:pointer; */}
//     cursor: ${({ isCursorPointer }) => (isCursorPointer ? isCursorPointer : "pointer")};
//     ${'' /* border-radius: 8px 0 0 8px; */}
//     border-radius: 7px 0px 0px 7px;
//     overflow: hidden;
//     >img{
//       width:100%;
//       height:100%;
//       object-fit: cover;
//       ${'' /* border-radius: 8px 0 0 8px; */}
//       border-radius: 7px 0px 0px 7px;
//     }
//   }
//   .detailsCard{
//     ${'' /* background:#F8F8F8; */}
//     width:638px;
//     padding:20px 0px 20px 20px;
//     display:flex;
//     border: none !important;       /* ← added */
//     box-shadow: none !important; 
//     flex-wrap:wrap;
//     flex-direction: column;
//     .title{
//       font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
//       font-size: 24px;
//       line-height: 24px;
//       font-style: normal;
//       font-weight: 700;
//       line-height: 36px;
//       width:100%;
//       color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
//       align-items: center;
//       display: flex;
//       ${'' /* margin-top: 20px */}
//     }
//     .details{
//         font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
//         font-weight: 400;
//         font-size: 16px;
//         font-style: normal;
//         line-height: 20px;
//         color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
//         width:100%;
//         display: flex;
//         align-items: center;
//         display: -webkit-box;
//         -webkit-line-clamp: 4;
//         -webkit-box-orient: vertical;
//         overflow: hidden;
//         text-overflow: ellipsis;
//         text-align: justify;
//         margin: 20px 0px 10px 0;
//     }
//     .time{
//         font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
//         font-size: 16px;
//         line-height: 20px;
//         color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
//         width:100%;
//         display: flex;
//         align-items: center;
//     }
//     .participant{
//         width:100%;
//         display:flex;
//         margin-bottom:22px;
//         width:100%;
//         .count{
//           background: #e6eff3;
//           ${'' /* border: 2px solid #FFFFFF; */}
//           border:none
//           border-radius: 15px;
//           padding:0 7px;
//           align-items: center;
//           display: flex;
//           height:fit-content;
//           margin: auto 0px;
//           .value{
//             font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
//             font-style: normal;
//             font-weight: 400;
//             font-size: 14px;
//             line-height: 20px;
//             color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
//           }
//         }
//         .participantJoined{
//             font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
//             font-style: normal;
//             font-weight: 400;
//             font-size: 14px;
//             line-height: 20px;
//             color:#669db7;
//             padding-left:10px;
//             align-items:center;
//             display:flex;
//         }
//     }
//     .buttonContainer{
//         margin-top:auto;
//         width:100%;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         gap: 16px;
//     }
//     .subContainer{
//       display:flex;
//       gap:16px;
//     }
//   }
// `;
const CompanyCard = styled.div`
  width: 100%;
  max-width: 100%;
  height: 344px;
  display: flex;
  cursor: ${({ isCursorPointer }) => (isCursorPointer ? isCursorPointer : "pointer")};
  border: 0.75px solid #DCDCDC;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
  
  .date {
    width: 100%;
    height: 32px;
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    
    .iconV1 {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
    }
    
    .detail {
      color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
      font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      margin-left: 20px;
      display: flex;
      align-items: center;
    }
  }
  
  .imageCardUserDashboard {
    width: 536px;
    min-width: 536px;
    object-fit: cover;
    height: 100%;
    flex-shrink: 0;
    cursor: ${({ isCursorPointer }) => (isCursorPointer ? isCursorPointer : "pointer")};
    
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  
  .detailsCard {
    flex: 1;
    min-width: 0;
    height: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    
    @media(min-width:1450px) and (max-width:1800px){
      border-right:0px solid #dcdcdc;
    }
    .title {
      font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
      font-size: 24px;
      font-weight: 700;
      line-height: 36px;
      color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
      margin-bottom: 20px;
    }
    
    .details {
      font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: ${({fontColor})=> fontColor ? fontColor : '#184A61'};
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 10px;
    }
    
    .buttonContainer {
      margin-top: auto;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;
    }
    
    .subContainer {
      display: flex;
      gap: 16px;
    }
  }
`;





const ReservedButton = styled.div`
  height: ${({height}) => height ? height : '40px'};
  width: ${({ width }) => width || '300px'};
  //min-width: ${({ minWidth }) => minWidth || 'unset'};  
  display: flex;
  background: ${({active,disabledBg}) => active ? "#DA6C74" : disabledBg ? disabledBg : 'transparent'};
  justify-content:center;
  align-items:center;
  border-radius: 6px;
  cursor:pointer;
  ${'' /* color: #FEFEFE; */}
  color: ${({active,disabledColor}) => active ? "#FEFEFE" : disabledColor ? disabledColor : ' #184A61'};
  border: ${({active}) => active ? "none" : '1px solid #DA6C74'};
  ${'' /* border:none; */}
  text-align: center;
  font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding: 12px 16px;
  gap: 8px;
  margin: ${({margin}) => margin ? margin : ''};

  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0px 6px 8px rgba(227, 79, 149, 0.25);   /* <– your specs */
    ${'' /* transform: translateY(-2px); */}
  }
  
  
  .icon{
    width:24px;
    height:24px;
    margin-right:12px;
    >img{
      width:100%;
      height:100%;
    }
  }
`;



const WeeklyFocusCardContainer = styled.div`
   display:flex;
   justify-content:center;
   gap:16px;
   margin-top:20px;
   margin-bottom:20px;

`;


const WeeklyFocusCard = styled.div`
  min-width: 165px;
  max-width:165px;
  height: 52px;
  flex-shrink: 0;
  border-radius: 8px;
  border: ${({isActive})=> isActive ? "none" : "0.75px solid #DCDCDC" };
  background:${({activeCard})=> activeCard ? activeCard : "white" } ;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;

  .textContainer{
    display: flex;
    ${'' /* width: 138px; */}
    height: 50px;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
    color: ${({isActive})=> isActive ? "#FEFEFE" : "#184A61" };
    text-align: center;
    font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; 
    padding:16px;
  }
  `;



const OuterCardContainer = styled.div`
{
    width: 1248px;
    display: flex;
    justify-Content: center;
    border: 0.75px solid #DCDCDC;
    padding: ${({ isOuterpadding }) => (isOuterpadding ? isOuterpadding : "0px 20px 46px 20px")};
    ${'' /* padding: 0px 20px 46px 20px; */}
    margin-Top: 20px;
    border-Radius: 12px;
    background: #FEFEFE;


    .insideCard{
        display: flex;
        height:216px;
        margin-top:20px;
        padding: 20px 8px;
        flex-direction: column;
        align-items: center;
        ${'' /* gap: 20px; */}
        align-self: stretch;
        border-radius: 8px;
        border: 0.75px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);


        .monthName{
                color: var(--Font-Color-on-Light-theme-500, #184A61);
                text-align: center;
                font-family: Lato;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
            }

        .monthlyDataContainer{
            display:flex;
            justify-content:center;
            align-items:center;
            gap:8px;
            margin: 20px 0px;
        }
}
`;




const StyledModal = styled(Modal)`
	.modal-dialog{
	display: flex;
    justify-content: center;
    transform: ${({ transform }) => transform && 'translate(0, 80px) translate(0, -90%) !important'};
	
    	.modal-content{
          max-height: ${({ maxHeight }) => maxHeight ? maxHeight : ''};
          width: ${({ newWidth }) => newWidth ? newWidth : '600px'};
    	  height: ${({ newHeight }) => newHeight ? newHeight : 'auto'};
    	  box-shadow: none;
    	  position: absolute;
    	  border-radius: 12px;

			.modal-header {
                padding:16px !important;
                background: ${({ newBg }) => newBg ? newBg : 'white'};
                border-bottom: none !important; /* ✅ Removes header bottom border */
        				border-radius: 12px;
        				height: ${({ height }) => height ? height : ''};
        				>button{
        				 display: ${({ display }) => display ? display : ''};
        				}

        				.modal-container 
                        {
         					width: 100%;
         					display: block;
       				    }
                color:  #184A61;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: 24px; 
			}
			.modal-header .close,
            .modal-header .btn-close {
     				margin-top: -2px;
     				outline: none !important;
     				display: none;
		}
	}}


  .modal-footer{
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items:center;
      border:none;
      padding:0px 16px 16px 16px;


      .wrapper {
       width: 100%;
      display: flex !important;
      justify-content: center !important; 
      align-items: center !important; 
      gap:16px;
}
    }
`;














const StyledModalWorkout = styled(Modal)`
	.modal-dialog{
	display: flex;
    justify-content: center;
    transform: ${({ transform }) => transform && 'translate(0, 80px) translate(0, -90%) !important'};
	
    	.modal-content{
        max-height: ${({ maxHeight }) => maxHeight ? maxHeight : ''};
        width: ${({ newWidth }) => newWidth ? newWidth : '600px'};
    	  height: ${({ newHeight }) => newHeight ? newHeight : 'auto'};
    	  box-shadow: none;
    	  position: absolute;
    	  border-radius: 12px;
        overflow-y: ${({ isOverFlow }) => isOverFlow ? isOverFlow : 'auto'};
        overflow-x:hidden;
        ${'' /* overflow-y: auto;   */}

			.modal-header {
                ${'' /* padding:16px !important; */}
                padding: ${({ isPadding }) => isPadding ? isPadding : '16px !important;'};
                background: ${({ newBg }) => newBg ? newBg : 'white'};
                border-bottom: none !important; /* ✅ Removes header bottom border */
        				border-radius: 12px;
        				height: ${({ height }) => height ? height : ''};
        				>button{
        				 display: ${({ display }) => display ? display : ''};
        				}

        				.modal-container 
                        {
         					width: 100%;
         					display: block;
       				    }
                color:  #184A61;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: 24px; 
			}
			.modal-header .close,
            .modal-header .btn-close {
     				margin-top: -2px;
     				outline: none !important;
     				display: none;
		}
	}}


  .modal-footer{
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items:center;
      border:none;
      padding:0px 16px 16px 16px;


      .wrapper {
       width: 100%;
      display: flex !important;
      justify-content: flex-end !important; 
      align-items: center !important; 
      gap:16px;


  .redirectionText{
    margin-top:20px;
    color:  #DA6C74;
    text-align: right;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    cursor:pointer;
   }
}
    }
`;



const HeaderText = styled.div`
   display:flex;
   flex-direction:column;
   gap:8px;
   width:100%;

   .subContainer{
    display:flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .closeIcon{
      cursor:pointer;
    }
   }
   .popupHeading{
    color:  #184A61;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; 
   }

`;


const DeviveHeaderText = styled.div`
   display:flex;
   flex-direction:column;
   justify-content:center;
   margin:auto;
   gap:8px;
   width:100%;

   .subContainer{
    display:flex;
    justify-content: center;
    align-items: center;
    width: 100%;
   }
   .popupHeading{
    display:flex;
    justify-content:center;
    align-items: center;
    color:  #184A61;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; 

    .icon{
      width:32px;
      height:32px;
      display:flex;
      justify-content:center;
      align-items:center;
      margin-right:4px;
    }
   }

`;




const StyledBody = styled(Modal.Body)`
 width: 100%;
 flex: 1; 
 max-height: 100%; 
 overflow-y:${({isOverFlow})=> isOverFlow ? isOverFlow : "auto" };
 font-family:Lato;
 ${'' /* padding: 20px !important; */}

 padding:${({isPadding})=> isPadding ? isPadding : "20px !important;" };

 .wrapper {
   width: 100%;
   display: flex !important;
   justify-content: center !important; 
   align-items: center !important; 
   margin-top: 16px; 
   gap:16px;
}

.wrapper-button {
   width: 100%;
   display: flex !important;
   justify-content: center !important; 
   align-items: center !important; 
   ${'' /* margin-top: 16px;  */}
   gap:16px;
}


.min-max-text{
color: var(--Font-Color-on-Dark-theme-100, #989898);
font-family: Lato;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
margin-top:4px;
}

.message{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  text-align: center;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
}


&::-webkit-scrollbar {
    width: 5px; /* scrollbar width */
    height:10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #BDBDBD; /* scrollbar thumb color */
    border-radius: 5.5px; /* rounded scrollbar thumb */
    min-height: 20px; 
    width: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #BDBDBD; /* darker on hover */
  }

  &::-webkit-scrollbar-track {
    background-color: #EFEFEF; /* track color */
    border-radius: 5.5px;
  }


  .gridContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
    width: 100%;
  }

  .redirectionText{
    margin-top:20px;
    color:  #DA6C74;
    text-align: right;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    cursor:pointer;
   }



`;



const Divider = styled.div`
  height: 1px;
  width: ${({ isWidth }) => (isWidth ? isWidth : "100%")};
  padding: ${({ isPadding }) => (isPadding ? isPadding : "")};
  background-color: #EFEFEF;
  margin: ${({ isMargin }) => isMargin || "0px 0px 10px 0px"};
  opacity: ${({ isOpacity }) => (isOpacity ? isOpacity : "100%")};
`;


const LogWorkoutCard = styled.div`
  display: flex;
  width:278px;
  height:64px;
  flex-direction: row;
  padding: 8px;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid  #EFEFEF;
  background:  #FEFEFE;
  cursor:pointer;

  .firstContainer{
    display:flex;
  }

  .wellnessInterest{
    display:flex;
    justify-content:center;
    align-items:center;
    margin-left:12px;
    color:  #184A61;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; 
  }

  .iconContainer{
    height:48px;
    width:48px;
    ${'' /* padding: 30px 10px; */}
    display:flex;
    justify-content:center;
    align-items:center;

    .img{
      height:24px;
      width:24px;
      flex-shrink: 0;
    }
  }
`;


const DateAndDayContainer = styled.div`
display: flex;
width: 100px;
padding\: 4px 0;
flex-direction: column;
align-items: center;
gap: 4px;
border-radius: 8px;
border: 1px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);
background: var(--Bg-Color-for-Light-theme-600, #FEFEFE);
background: ${({isBg})=> isBg ? isBg : "#FEFEFE" };
cursor: ${({isCursor})=> isCursor ? isCursor : "pointer"}

.dateText{
  width:36px;
  height:36px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.color || "#000"};
  text-align: center;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
}

.dayText{
  color: ${(props) => props.color || "#000"};
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 125% */
  
}

`;


const NoBorderButton = styled.div`
display: flex;
height: 40px;
padding: 12px 16px;
justify-content: center;
align-items: center;
gap: 8px;
color:#184A61;
cursor:pointer;
`;



const DisableEnableButton = styled.div`
  height: ${({height}) => height ? height : '40px'};
  width: ${({ width }) => width || '300px'};
  //min-width: ${({ minWidth }) => minWidth || 'unset'};  
  display: flex;
  background: ${({active,disabledBg}) => active ? "#DA6C74" : disabledBg ? disabledBg : 'transparent'};
  justify-content:center;
  align-items:center;
  border-radius: 6px;
  cursor:pointer;
  ${'' /* color: #FEFEFE; */}
  color: ${({active,disabledColor}) => active ? "#FEFEFE" : disabledColor ? disabledColor : ' #184A61'};
  ${'' /* border:none; */}
  text-align: center;
  font-family: ${({fontFamily})=> fontFamily ? fontFamily : "Lato"};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding: 12px 16px;
  gap: 8px;
  margin: ${({margin}) => margin ? margin : ''};
  cursor: ${({isCursor})=>isCursor ? "pointer" : "not-allowed"}
  
  
  .icon{
    width:24px;
    height:24px;
    margin-right:12px;
    >img{
      width:100%;
      height:100%;
    }
  }
`;




const ConnectedDeviceCard = styled.div`
  display:flex;
  width: 1248px;
  height: 264px;
  flex-shrink: 0;
  margin: 0 0 20px 0;
  
  


  background-image: ${({ bgImage }) => `url(${bgImage})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  background-color: rgba(254, 254, 254, 0.80);
  backdrop-filter: blur(57px);
  border-radius: 12px;
  padding: 16px 16px 20px 20px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 12px;     /* Match card corners */
    pointer-events: none;    /* Do not block clicks */
    z-index: 1;
   
  }


  .insideContainer{
    display:flex;
    position: relative;   
    width: 100%; 
    justify-content: space-between;   /* Push them apart */
    align-items: center;  

    .firstContainer{
      display:flex;
      flex-direction:column;
      z-index:100;
      ${'' /* margin:auto; */}
    }

    .secondContainer{
      margin-left: auto;  /* pushes it to the right end */
      display: flex;
      flex-direction: row;
      ${'' /* align-items: center; */}
      justify-content: flex-start;
      height: 100%;
      position: relative;
      gap:44px;
    }
  }


  .deviceHeading{
   display:flex;
   gap:4px;
   align-items:center;
   z-index:50;

   .iconContainer{
    width:18px;
    height:18px;
    display:flex;
    justify-content:center;
    align-itmes:center;
   }

   .headingText{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
   font-family: Lato;
   font-size: 18px;
   font-style: normal;
   font-weight: 700;
   line-height: 24px; /* 133.333% */
   }
  }

  .headingSubText{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
    margin-top:20px;
   }
  `;

const DeviceContainerWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  width: 100%;
`;



const DeviceContainer = styled.div`
  display: flex;
  width: 96px;
  height: 96px;
  ${'' /* padding: 60px 20px; */}
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 80px;
  border: 0.4px solid var(--Bg-Color-for-Light-theme-200, #BDBDBD);
  ${'' /* background: url(<path-to-image>) lightgray 50% / cover no-repeat; */}
  
  `;


const CrossIconContainer = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  border-radius: 167.4px;
  border: 1px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);
  background: var(--Bg-Color-for-Light-theme-600, #FEFEFE);
  
  `;




const StyledModalDevice = styled(Modal)`
	.modal-dialog{
	display: flex;
    justify-content: center;
    transform: ${({ transform }) => transform && 'translate(0, 80px) translate(0, -90%) !important'};
	
    	.modal-content{
          max-height: ${({ maxHeight }) => maxHeight ? maxHeight : ''};
          width: ${({ newWidth }) => newWidth ? newWidth : '418px'};
    	  height: ${({ newHeight }) => newHeight ? newHeight : 'auto'};
    	  box-shadow: none;
    	  position: absolute;
    	  border-radius: 12px;

			.modal-header {
                padding:16px !important;
                background: ${({ newBg }) => newBg ? newBg : 'white'};
                border-bottom: none !important; /* ✅ Removes header bottom border */
        				border-radius: 12px;
        				height: ${({ height }) => height ? height : ''};
        				>button{
        				 display: ${({ display }) => display ? display : ''};
        				}

        				.modal-container 
                        {
         					width: 100%;
         					display: block;
       				    }
                color:  #184A61;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: 24px; 
			}
			.modal-header .close,
            .modal-header .btn-close {
     				margin-top: -2px;
     				outline: none !important;
     				display: none;
		}
	}}


  .modal-footer{
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items:center;
      border:none;
      padding:0px 16px 16px 16px;


      .wrapper {
       width: 100%;
      display: flex !important;
      justify-content: center !important; 
      align-items: center !important; 
      gap:16px;
}
    }
`;



const StyledBodyWellness = styled(Modal.Body)`
 width: 100%;
 flex: 1; 
 max-height: 100%; 
 overflow-y:${({isOverFlow})=> isOverFlow ? isOverFlow : "auto" };
 font-family:Lato;
 padding:${({isPadding})=> isPadding ? isPadding : "20px !important;" };

   .message{
     color: var(--Font-Color-on-Light-theme-500, #184A61);
     text-align: center;
     font-family: Lato;
     font-size: 16px;
     font-style: normal;
     font-weight: 400;
     text-align:left;
     line-height: 20px; /* 125% */
     margin-bottom:12px;
   }
   
   
   &::-webkit-scrollbar {
       width: 5px; /* scrollbar width */
       height:10px;
     }
   
     &::-webkit-scrollbar-thumb {
       background-color: #BDBDBD; /* scrollbar thumb color */
       border-radius: 5.5px; /* rounded scrollbar thumb */
       min-height: 20px; 
       width: 4px;
     }
   
     &::-webkit-scrollbar-thumb:hover {
       background-color: #BDBDBD; /* darker on hover */
     }
   
     &::-webkit-scrollbar-track {
       background-color: #EFEFEF; /* track color */
       border-radius: 5.5px;
     }


`;



const WellnessCategrydCard = styled.div`
  display: flex;
  flex-direction: column;
  ${'' /* padding: 16px; */}
  border-radius: 12px;
  background: var(--Light-Card, rgba(254, 254, 254, 0.60));
  ${'' /* margin-bottom: 20px; */}
  width: 100%;

  .heading-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }

  .edit-btn {
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
  }

  .pencil-icon {
    margin-left: 8px;
  }

  .heading {
    color: #184A61;
    font-family: Lato;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }

  .headerContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .wellness-interest {
    display: flex;
    flex-wrap: wrap;
    gap: 20px 8px;
    width: 100%;
  }

  .wellnessTypeContainer {
    display: flex;
    padding: 12px 8px;
    align-items: center;
    gap: 12px;
    border-radius: 12px;
    background: var(--Light-Card, rgba(254, 254, 254, 0.60));
    min-width: 24%;
    max-width: 100%;

    .contentHeading {
      color: #184A61;
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }

    .value {
      color: #184A61;
      font-family: Lato;
      font-size: 18px;
      font-weight: 700;
      line-height: 20px;
    }
  }

  .iconWrapper {
    display: flex;
    width: 48px;
    height: 48px;
    justify-content: center;
    align-items: center;
    border-radius: 40px;
    background: ${({ isColor }) => isColor || '#92A4DA'};
  }

  .activity-name,
  .activity-count {
    color: #184A61;
    font-family: Lato;
  }

  .activity-name {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-transform: capitalize;
  }

  .activity-count {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }

  @media (max-width: 1024px) {
    .wellnessTypeContainer {
      flex: 1 1 calc(33.33% - 16px);
    }
  }

  @media (max-width: 768px) {
    .wellnessTypeContainer {
      flex: 1 1 calc(50% - 16px);
    }
  }

  @media (max-width: 480px) {
    .wellnessTypeContainer {
      flex: 1 1 100%;
    }
  }
`;




const CategoryCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  width: 100%;
  margin-top:4px;

  border-radius: 8px;
  border: 0.75px solid  #EFEFEF;
  background:  #FEFEFE;

  .interest-container {
    display: flex;
    height:47px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .interestType {
    color: #184A61;
    font-family: 'Lato';
    font-size: 16px;
    font-weight: 400;
    line-height: 18px;
    text-transform: capitalize;
  }

  .dropicon {
    transition: transform 0.3s ease;
    width:32px;
    height:32px;
    display:flex;
    justify-content:center;
    align-items:center;
  }

  .dropdown-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
  }

  @media (max-width: 600px) {
    .interestType {
      font-size: 16px;
    }
  }
`;


const DropdownContent = styled.div`
  display: flex;
  height: 40px;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 40px;
  border:${({ isBorder }) => (isBorder ? isBorder : "0.75px solid #EFEFEF")};
  ${'' /* border: 0.75px solid #EFEFEF; */}
  background: ${({ userInterest }) => (userInterest ? "#DA6C74" : "white")};
  font-weight: 600;
  color: ${({ userInterest }) => (userInterest ? "white" : "#184A61")};
  cursor: pointer;
  transition: background 0.3s;

  :hover{
    background: ${({ userInterest }) => (userInterest ? "#DA6C74" : "#DA6C74")};
    color:white;
    ${'' /* color: ${({ userInterest }) => (userInterest ? "#184A61" : "white")}; */}
    ${'' /* border: ${({ userInterest }) => (userInterest ? "none" : "0.75px solid #DCDCDC")}; */}
    box-shadow: 0 6px 8px 0 rgba(227, 79, 149, 0.25);
  }

  &:hover > img {
    filter: brightness(0) invert(1);
  }


  > img {
    width: 24px;
    height: 24px;
    border-radius:50%;
  }

  .listContent {
    ${'' /* color: ${({ userInterest }) => (userInterest ? "white" : "#184A61")}; */}
    font-family: 'Lato';
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;

    :hover {
      ${'' /* color: ${({ userInterest }) => (userInterest ? "#184A61" : "white")}; */}
    }
  }

  @media (max-width: 480px) {
    flex: 1 1 100%;
    justify-content: flex-start;
    padding: 8px;
  }
`;




const CardContent = styled.div`
  display: flex;
  height: 40px;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 40px;
  border: 0.75px solid #EFEFEF;
  background: ${({ userInterest }) => (userInterest ? "#DA6C74" : "white")};
  font-weight: 600;
  color: ${({ userInterest }) => (userInterest ? "white" : "#184A61")};
  cursor: pointer;
  transition: background 0.3s;


  .category-img {
    width: 24px;
    height: 24px;
    transition: filter 0.3s ease;
    filter: ${({ userInterest }) =>
    userInterest ? "brightness(0) invert(1)" : "none"};
  }

  ${'' /* > img {
    width: 24px;
    height: 24px;
  } */}

  .listContent {
    ${'' /* color: ${({ userInterest }) => (userInterest ? "white" : "#184A61")}; */}
    font-family: 'Lato';
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;

    ${'' /* :hover{
      color: ${({ userInterest }) => (userInterest ? "#184A61" : "white")};
    } */}
  }

  @media (max-width: 480px) {
    flex: 1 1 100%;
    justify-content: flex-start;
    padding: 8px;
  }
`;




const SliderContainerV1 = styled.div`
  width: 100%;

  .slick-slider {
    width: 100%;
    margin: ${({marginValue}) => marginValue ? marginValue : '20px 0 10px'};
    padding: ${({padding}) => padding ? padding : ''};
    box-shadow: none;

    .slick-slide{
      ${'' /* margin-right: 2px; */}
      display: flex;
      justify-content: ${({ content }) => content ? content : 'center'};
      ${'' /* justify-content: center; */}
      display: ${({display}) => display ? display : 'block'};
      ${'' /* justify-content: ${({content}) => content ? content : ''}; */}
      margin: ${({margin}) => margin ? margin : ''};
      @media (max-width: 600px){
        margin: 0 auto;
      }
    }
    .slick-prev {
      display:none !important;
    }
     .slick-list {
      margin-left: -10px;
      
    }  
    .slick-track {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    ${'' /* margin-left: auto;  */}
    ${'' /* margin-right: auto; */}
    margin-left: ${({ content }) => content ? "0 !important" : 'auto'};
    margin-right:${({ content }) => content ? "0 !important" : 'auto'};
    }
    

    .slick-next {
      display:none !important;
    }
      [dir="rtl"] .slick-next:before {
        content: "‹";
      }
       .slick-dots{
        li{
        margin:0px;
        }
        li button:before {
              font-size: 10px;
        }
         li:hover button:before{
           color: #DA6C74 !important;
         }
        li.slick-active button:before {
          opacity: 1;
          color: #DA6C74 !important;
        }
      }
  }
`;








const SliderContainerNew = styled.div`
  width: 100%;
  .slick-slider {
    ${'' /* width: 100%; */}
    ${'' /* width: 100% !important; */}
    margin: ${({ marginValue }) => (marginValue ? marginValue : "20px 0 10px")};
    padding: ${({ padding }) => (padding ? padding : "")};
    box-shadow: none;

    .slick-slide {
      display: flex !important;
    padding-right: 20px;
     }
     .slick-list {
       margin-right: -20px;
     }
    
    

    .slick-list {
      overflow: hidden !important;
      
    }

    .slick-track {
      display: flex !important;
      ${'' /* gap:20px !important: */}
    }

    /* 👇 Center dots below the card */
    .slick-dots {
      margin: 0; /* removes slick’s default margin */
      padding: 0;
      position: absolute;
      width: 10px;
      height: 10px;
      bottom: -25px; /* adjust as needed, e.g. -15px or -30px */
      left: 50%;
      transform: translateX(-50%);
      display: flex !important;
      justify-content: center;
      align-items: center;
      gap: 8px; /* spacing between dots */
    }

    .slick-dots li {
    position: relative;
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 0;
    padding: 0;
    pointer-events: none !important;
    ${'' /* cursor: pointer; */}
    }


    .slick-dots li button {
     width: 10px;
     height: 10px;
     border-radius: 50%;
     background: #d9d9d9;
     border: none;
     padding: 0;
     ${'' /* cursor: pointer; */}
     pointer-events: none !important;
     cursor: default !important;
   }
   .slick-slide > div {
    padding: 0 !important;
    margin: 0 !important;
    outline: none !important;
    border:none !important;
  }

  slick-slide > div {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

   .slick-slide,
  .slick-track,
  .slick-list {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    height:285px;
}

.slick-slide:focus {
  outline: none !important;
  border:none !important;
}

.slick-slide  {
  width: auto !important;
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}  


    .slick-dots li button:before {
  display: none;
}

    .slick-dots li.slick-active button:before {
      color: #ff6b6b; /* active dot color, adjust to match your design */
    }
   
    .slick-slide {
      ${'' /* width: 1225px !important; */}
      width: auto !important;
      display:flex;
      border:none !important;
      outline: none !important;
      justify-content: ${({ content }) => (content ? content : "")};
      margin: ${({ margin }) => (margin ? margin : "")};
      @media (max-width: 600px) {
        margin: 0 auto;
      }
    }



   .slick-dots li.slick-active button {
     background: #DA6C74; /* 🔵 your active color */
     width: 10px; /* optional: slightly bigger when active */
     height: 10px;
   }

    .slick-prev,
    .slick-next {
      display: none !important;
    }

    [dir="rtl"] .slick-next:before {
      content: "‹";
    }

    ${'' /* * {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
} */}

*:not(.slick-slider *):not(.slick-track):not(.slick-slide) {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
   
  }
`;

const WolibaThursdayCard = styled.div`
border-radius: 8px;
${'' /* border: 0.75px solid #DCDCDC; */}
height:344px;

.image-container{
  position:relative;

  >img{

  }
}

.affirmation-text{
  position:absolute;
  top:0;
  display:flex;
  justify-content:center;
  width:100%;
  height:275px;
  align-items:center;

  color: ${({ color }) => (color ? color : "#8D4964")};
text-align: center;
font-family: Lora;
font-size: 32px;
font-style: italic;
font-weight: 400;
line-height: 52px; 

}

.bottom-container{
  height:69px;
  align-items:center;
  padding:20px;
  display:flex;
  justify-content:space-between;
}
.likes-container{
  display:flex;
  align-items:center;
}
.like-icon{
  display:flex;
  cursor:pointer;
}

.likes-count{
  color: #184A61;
font-family: Lato;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 14px;
margin-left:12px;
}

.affirmation-bottom-text{
  color: #DA6C74;
text-align: right;
font-family: Lato;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 18px;
}

`

const CalendarLinkCard = styled.div`
background-image: url(${CalendarLinkBgImage});
background-repeat: no-repeat;
${'' /* background-size: cover; */}
height:80px;
width:1248px;
display:flex;
align-items:center;
justify-content:space-between;
padding:20px;
margin:20px 0px;

.text{
  color: #2F6C42;
font-family: Lato;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 30px;
}

`


const TypeContainer = styled.div`
display: flex;
width: 48px;
height: 48px;
${'' /* padding: 30px 10px; */}
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 40px;
background: var(--Font-Color-on-Light-theme-500, #184A61);
`;



const HeaderContainer = styled.div`
  display:flex;
  margin-top:16px;
  flex-direction:row;
  gap:12px;
  justify-content:flex-start;
  align-items:center;
  .title{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
  }
`;


const GoalTableContainer = styled.div`
  ${'' /* margin-top: 24px; */}

  .table-header{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 24px 16px 24px 16px;
    align-items: center;
    .firstColumn{
      display:flex;
      justify-content:flex-start;
    }
    .lastColumn{
      display:flex;
      justify-content:flex-end;
    }

    .heading{
      color: #184A61;
      text-align: center;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px; 
    }
  }
  .table-row {
    display: grid;
    margin-bottom:8px;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 12px 16px;
    align-items: center;
    border-radius: 4px;
    height: 48px;
    align-self: stretch;
    background: var(--Bg-Color-for-Light-theme-500, #F8F8F8);

    color: var(--Font-Color-on-Light-theme-500, #184A61);
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 

    .lastColumn{
      display:flex;
      justify-content:flex-end;
    }

  }
  
  .level {
    display: flex;
    gap: 12px;
    align-items: center;
  }



  .table-row {
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #ececec;
  }

  &.selected {
    background: #DA6C74;
    color: #ffffff;

    span {
      color: #ffffff;
    }
  }
}
`;



const ProgressContainer = styled.div`
  display:flex;
  justify-content:space-between;


  .progressText{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    font-size:${({isFontSize}) => isFontSize ? isFontSize : '14px'};
    font-style: normal;
    font-weight: 400;
    line-height: 18px; 

    .value{
      font-size:${({isFontSize}) => isFontSize ? isFontSize : '14px'};
      font-style: normal;
      font-weight: 700;
      line-height: 18px; 
    }

`;



const ProgressBar = styled.div`
    width: 631.045px;
    height: 12px;
    border-radius: 16px;
    margin-top:8px;
    overflow: hidden;
    background: var(--Bg-Color-for-Light-theme-400, #EFEFEF);

    .barWidth{
      height: 100%;
      width: ${({progress}) => progress ? progress : '0%'}; 
      ${'' /* background: #DA6C74; */}
      background-color:${({isColor}) => isColor ? isColor : '#DA6C74'};
      border-radius: 16px;
    }
`;

const ChallengesContainer = styled.div`
width:100%;
height:56px;
display:flex;
justify-content:space-between;
padding: 8px;
align-items:center;
margin-bottom:20px;
border-radius: 12px;
border: 0.75px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);
background: var(--Bg-Color-for-Light-theme-600, #FEFEFE);


    .title{
      color: var(--Font-Color-on-Light-theme-500, #184A61);
      font-family: Lato;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 30px; 
    }
    .icon{
      margin-right:12px;
      cursor:pointer;
      width:32px;
      height:32px;
      display:flex;
      justify-content:center;
      align-items:center;
    }
    .right-row{
      display:flex;
      align-items:center;
    }
    
    
    .action-icons {
      display: flex;
      align-items: center;
      margin-left: auto;
    }
    
    
    .edit-icon{
      margin-left:20px;
      cursor:pointer;
    }
    
    .icon-background{
      display: flex;
      width: 32px;
      height: 32px;
      padding: 7px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      border-radius: 4px;
      background: var(--Crimson-Blush-100, #FCF2F3);
    
    }
    
    .left-row{
      display:flex;
      align-items:center;
    
      .icons{
        background:#FCF2F3;
        ${'' /* padding:6px; */}
        border-radius:4px;
        width:32px;
        height:32px;
        display:flex;
        justify-content:center;
        align-items:center;
        cursor:pointer;
      }
    
      .favourite-icon{
        margin-left:20px;
        cursor: pointer
      }
    }

    .exit-challenge{
      display:flex;
      align-items: center;
      margin-left: auto;

    }

`;



const ChallengeHeading = styled.div`
   color:  #184A61;
   font-family: Lato;
   font-size: 24px;
   font-style: normal;
   font-weight: 700;
   line-height: 30px;
   margin:20px 0;
`;



const ChallengeDetailsConatainer = styled.div`
   display: flex;
   width: 1248px;
   padding: 20px 20px 28px 20px;
   ${'' /* justify-content: center; */}
   ${'' /* align-items: center; */}
   border-radius: 12px;
   border: 0.75px solid  #DCDCDC;
   background:  #FEFEFE;
  

   .insideConatainer{
    display: flex;
   flex-direction: row;
   gap:20px;

   .leftContainer{
    display: flex;
    width: 752px;
    flex-direction: column;

    .AboutHeading{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
   }
   .des{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
   }
   }
   }


   .rewardBox{
    display:flex;
    gap:20px;
    margin-top:12px;
    height:32px;

    .rewardHeading{
      width:318px;
      color:  #2F6C42;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px; 
    }

    .rewardValue{
      color: #184A61;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; 

    }
   }

  /* index.css or App.css */

   



`;


const ImageLayout = styled.div`
   width: 752px;
   height: 472px;
   border: 1px solid  #EFEFEF;
   ${'' /* background-color: lightgray; */}
   border-radius:12px;
   ${'' /* background: url(<path-to-image>) lightgray 50% / cover no-repeat, url(<path-to-image>) lightgray 50% / cover no-repeat; */}
   img {
    width: 100%;
    height: 100%;
    border-radius:12px;
    object-fit: cover; /* or contain */
    display: block;
  }
  
`;


const DateLocationContainer = styled.div`
  display: flex;
  gap:12px;
  alignItems: center;

  .insideBox{
    display:flex;
    gap:20px;
    height:32px;

    .text{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
     font-family: Lato;
     font-size: 16px;
     font-style: normal;
     font-weight: 400;
     line-height: 20px; /* 125% */
     width:318px
  }
  }

  
`;



const LevelConatiner = styled.div`
    display: flex;
    gap:20px;
    margin-bottom:20px;
    ${'' /* padding: 16px; */}
    padding: ${({isPadding})=> isPadding ? isPadding : '16px'};
    align-items: center;
    align-self: stretch;
    border-radius: 12px;
    border: 0.75px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);

    .dateContainer{
     position: absolute;
     top: 16px;
     right: 16px;
     color:  #7C7C7C;
     text-align: center;
     font-family: Lato;
     font-size: 16px;
     font-style: normal;
     font-weight: 400;
     line-height: 20px;
    }

    .graphContainer{
      display: flex;
      align-items: center;
    }

    .graphContent{
      width: 150px;
      display: flex;
      justify-content: flex-start;
    }
    .stepsDetails{
      font-size: 24px;
      font-weight: 700;
      color:#184A61;
    }
`




const RightContainer = styled.div`
  display: flex;
  width:436px;
  padding: 16px 8px;
  flex-direction: column;
  align-items: center;
  font-family: Lato;
  align-self: stretch;
  border-radius: 6px;
  border: 1px solid var(--Bg-Color-for-Light-theme-400, #EFEFEF);
  background: var(--Bg-Color-for-Light-theme-600, #FEFEFE);


  

  .levelImage{
    display: flex;
    width: 48px;
    height: 48px;
    padding: 12px;
    justify-content: center;
    align-items: center;
    border-radius: 40px;
    border: 1px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);
    background: var(--Bg-Color-for-Light-theme-500, #F8F8F8);
  }

  .levelName{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    ${'' /* margin-left:20px; */}
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; 
  }

     .statsRow{
       display: flex;
       justify-content: space-between;
       width: 100%;
       padding: 0 12px;
       margin-bottom:20px
     }
     
     .statBox{
       display: flex;
       flex-direction: column;
       gap: 6px;
     }
     
     .label{
       color: #DA6C74;
       font-size: 16px;
       font-weight: 700;
       line-height: 20px;
     }
     
     .value{
       color: #184A61;
       font-size: 24px;
       font-weight: 700;
       line-height: 36px;

       .stepText{
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
       }
     }

     .pointeSection{
      display:flex;
      margin-top:8px;
      justify-content:space-between;
      align-items: center;
      width: 100%;
     

      .heading{
      color: var(--Font-Color-on-Light-theme-500, #184A61);
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; 
      }

      .pointValue{
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
      }

      .icon{
        cursor:pointer;
      }
      
     }
     
`;



const BottomContainer = styled.div`

  .row{
    display:flex;
    gap:12px;
    margin-bottom:20px;
  }

  .secondRow{
    display:flex
  }

  .seconRowMargin{
    margin-top:16px;
  }

  .rowContennt{
    display:flex;
    gap:4px;
  }

  .boldTexBox{
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-weight: 700;
    width:362px;
  }

  .textBox{
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    width:232px;
  }

`;

const ColorBox = styled.div`
width: 20px;
height: 20px;
border-radius:50%;
background-color:${({isColor})=> isColor ? isColor : "#DDEEDF"};

`;



const ProgressCard = styled.div`
  display:flex;
  flex-direction:column;

  .progressCard{
    display:flex;
    justify-content:space-between;
    margin-bottom:8px;
  }

  .progressText{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    font-size:${({isFontSize}) => isFontSize ? isFontSize : '16px'};
    font-style: normal;
    font-weight: 400;
    line-height: 18px; 

    .value{
      font-size:${({isFontSize}) => isFontSize ? isFontSize : '16px'};
      font-style: normal;
      font-weight: 700;
      line-height: 18px; 
    }
  }

  .ProgressBar{
    width: 420px;
    height: 30px; 
    overflow: hidden;
    border-radius:${({isBorder}) => isBorder ? isBorder : '16px'};
    background-color: #EFEFEF;

    .insideBar{
    width:${({isWidth}) => isWidth ? `${isWidth}%` : '0%'};
    height: 30px;
    border-radius: 16px;
    background-color:${({isColor}) => isColor ? isColor : '#DA6C74'};
    }
  }

`;




const MonthlyCalendar = styled.div`
  width: 100%;

    
  .react-calendar {
    width: 100% !important;
    border: none;
    background: white;
  }

  /* Header (month + arrows) */
  .react-calendar__navigation {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    button {
      background: none;
      border: none;
      font-size: 18px;
      cursor: pointer;
    }
  }

  .react-calendar__navigation__arrow {
  display: none !important;
}


   .react-calendar__tile.future {
     background: #F8F8F8 !important;
     color: #7C7C7C !important;
     cursor: not-allowed;
   }
   .react-calendar__month-view__weekdays abbr {
     text-decoration: none !important;
     border-bottom: none !important;
     cursor: default;
   }

   .react-calendar__month-view__weekdays__weekday:hover {
     background: transparent !important;
   }


  /* Week days */
  .react-calendar__month-view__weekdays {
    text-align: center;
    font-size: 16px;
    height:36px;
    color: #BDBDBD !important;
    margin-bottom:16px;
    font-weight: 400 !important;
l   line-height: 20px !important;
  }

  /* Grid layout */
  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    height:208px;
  }

   

  /* Each day tile */
  .react-calendar__tile {
    height: 28px;
    border-radius: 4px;
    border: none;
    background: #f8f8f8;
    font-size: 16px;
    font-wight:400;
    line-height:20px;
    color: #184a61;
  }

  /* Hide outside month days */
        .react-calendar__month-view__days__day--neighboringMonth {
          opacity: 0;
          pointer-events: none;
        }
      
        .react-calendar__navigation__label {
          flex-grow: 0 !important;
        }
       
         .react-calendar__navigation {
         justify-content: center;
       }
       
       .react-calendar__navigation__arrow {
         display: none !important;
       }
       
       .react-calendar__navigation__label {
         flex-grow: 0 !important;
         font-weight: 600;
         color: #0F3D5E; /* match your design */
       }
       
       
       
         .react-calendar__navigation button {
          display: none;
         }
         
         .react-calendar__navigation__label {
           display: block !important;
         }
       
       
         .react-calendar__navigation__label {
         background: none !important;
         font-weight: 700;
         font-size: 16px;
         color: #184a61;   /* Figma dark blue */
        }
        
        .react-calendar__navigation__label span {
          color: #184a61;
        }
       
       
        .react-calendar__navigation {
         justify-content: center;
         gap: 12px;
         margin-bottom:16px !important;
       }


  /* Today (blue like Figma) */
 
  /* Selected / completed */
  .completed {
    background: #dfeee2 !important;
  }

  /* Not completed */
  .missed {
    background: #f6d5d6 !important;
  }

  ${'' /* .react-calendar__tile--now {
    background: #D3DEF2 !important;
    border: 1px solid #92A4DA !important;
    border-radius: 4px; 
    color: #184A61;
  } */}

  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: #D3DEF2 !important;
    ${'' /* border: 1px solid #92A4DA !important; */}
  }


    ${'' /* .react-calendar__tile.selected {
    border-radius: 4px;
    border: 1px solid var(--Serene-Blue-500, #92A4DA);
    background: var(--Serene-Blue-300, #D3DEF2) !important;
    color: #184A61;
  } */}

  
  .react-calendar__tile.selected {
  border-radius: 4px;
  ${'' /* border: 1px solid var(--Serene-Blue-500, #92A4DA); */}
  background: var(--Serene-Blue-300, #D3DEF2) !important;
  color: #184A61;
}
  
  /* Ensure selected overrides completed/missed */
  .react-calendar__tile.completed.selected,
  .react-calendar__tile.missed.selected {
    background: var(--Serene-Blue-300, #D3DEF2) !important;
    ${'' /* border: 1px solid var(--Serene-Blue-500, #92A4DA); */}
  }

`;






export {WellnessCategrydCard,CardContent, HeaderContainer,ProgressCard,ProgressContainer,  CalendarLinkCard ,MonthlyCalendar,ColorBox,LevelConatiner, BottomContainer,DateLocationContainer, RightContainer, ImageLayout, ChallengeDetailsConatainer, ChallengeHeading, ChallengesContainer, TypeContainer, GoalTableContainer, SliderContainerV1, SliderContainerNew,CategoryCard,DropdownContent,StyledBodyWellness,StyledModalDevice,DeviveHeaderText, MonthlythemeContainer,TopCards,TopCardsContainer,ProgressBar,ProgressBarContainer,Layout,Container,SliderContainer,CompanyCard,ReservedButton,WeeklyFocusCardContainer,OuterCardContainer,StyledModal,HeaderText,StyledBody , Divider,LogWorkoutCard,WeeklyFocusCard,DateAndDayContainer,NoBorderButton,DisableEnableButton,StyledModalWorkout,ConnectedDeviceCard,DeviceContainer,CrossIconContainer,DeviceContainerWrapper, TopThreeInitiativesCard,WolibaThursdayCard };
